module.exports = __webpack_public_path__ + "img/introduce4.b1d84edb.png";